namespace $.$$ {

	export class $shm_hitalama_quick2 extends $.$shm_hitalama_quick2 {

		@ $mol_mem
		ids( next?: string[] ) {
			return next ?? []
		}

		@ $mol_mem
		buttons() {
			return this.ids().map( id => this.Button( id ) )
		}

		item_title( id: any ): string {
			return ''
		}

		item_hotkey( id: any ): string {
			return ''
		}

		item_label( id: any ): any {
			return [ ... this.item_title( id ) ][0] ?? ''
		}

		@ $mol_action
		activate( id: string ) {
			this.checked( id, !this.checked( id ) )
		}

		@ $mol_mem
		keydown_handler() {
			return $mol_wire_async( ( event: KeyboardEvent )=> {
				if( event.defaultPrevented ) return
				if( $shm_hitalama_is_input_focused() ) return

				const id = this.ids().find( id => this.hotkey_matches( event, this.item_hotkey( id ) ) )
				if( !id ) return

				event.preventDefault()
				this.activate( id )
			} )
		}

		hotkey_matches( event: KeyboardEvent, hotkey: string ) {
			const parts = hotkey.toLowerCase().split( '+' ).map( part => part.trim() ).filter( Boolean )
			if( !parts.length ) return false

			const key = parts.at( -1 )
			if( !key ) return false

			const modifiers = new Set( parts.slice( 0, -1 ) )
			if( event.ctrlKey !== modifiers.has( 'ctrl' ) ) return false
			if( event.shiftKey !== modifiers.has( 'shift' ) ) return false
			if( event.altKey !== modifiers.has( 'alt' ) ) return false
			if( event.metaKey !== ( modifiers.has( 'meta' ) || modifiers.has( 'cmd' ) ) ) return false

			if( /^[a-z]$/.test( key ) ) return event.code === `Key${ key.toUpperCase() }`
			if( /^[0-9]$/.test( key ) ) return event.code === `Digit${ key }`

			return event.key.toLowerCase() === key
		}

		pointerenter( id: any, next?: any ) {
			this.hovered_id( id )
		}

		pointerleave( id: any, next?: any ) {
			this.hovered_id( '' )
		}

		@ $mol_mem
		hovered_title_visible(): readonly ( any )[] {
			if( this.ids().length === 0 ) return []
			return this.hovered_id() ? super.hovered_title_visible() : []
		}

		@ $mol_mem
		hovered_title(): string {
			const id = this.hovered_id()
			return id ? this.item_title( id ) : ''
		}

	}

}
